import { Title } from "@components";
import styles from "@styles/pages/reports/reports.module.scss";
import { Link } from "react-router-dom";

export default function CustomersReports() {
  const pages = [
    {
      name: "Clientes identificados",
      icon: <i className="fal fa-user" />,
      path: "clientes-identificados",
      enabled: true,
    },
    {
      name: "Perfis RFV",
      icon: <i className="fal fa-medal" />,
      path: "perfis-rfv",
      enabled: true,
    },
    {
      name: "Ciclo de Vida",
      icon: <i className="fal fa-arrows-spin" />,
      path: "ciclo-de-vida",
      enabled: true,
    },
    {
      name: "Novos cadastros",
      icon: <i className="fal fa-users" />,
      path: "novos-cadastros",
      enabled: true,
    },
  ];

  return (
    <>
      <Title title="Relatórios de Clientes" />

      <div className={styles.reports}>
        {pages
          .filter((p) => !!p.enabled)
          .map((page, index) => {
            return (
              <Link to={page.path} key={page.name}>
                <div className={styles.report} style={{ opacity: 1 }}>
                  <div className={styles.icon}>{page.icon}</div>
                  <p>{page.name}</p>
                </div>
              </Link>
            );
          })}
      </div>
    </>
  );
}
